import React from 'react';

// Style and SEO
import { css, up, styled, th } from '@smooth-ui/core-sc';
import { Link } from 'react-router-dom';

import { withSettings } from 'containers/WebApp/SettingsContext';
import FooterLogo from './images/footer-logo.svg';

import PatternImg from './images/footer-pattern.svg';

const FooterWrapper = styled.footer`
  margin-top: -15px;
  color: #8b8b8d;
  z-index: 1;

  .pattern-container {
    position: relative;
    width: 100%;
    height: 24px;

    .pattern {
      position: absolute;
      height: 100%;
      width: auto;
      right: 30%;
    }

    &::before {
      content: ' ';
      position: absolute;
      width: 100vw;
      height: 100%;
      right: 37%;
      background-color: ${th('primary')};
      ${up(
        'sm',
        css`
          right: 33%;
        `
      )};
    }

    &::after {
      content: ' ';
      position: absolute;
      width: 100vw;
      height: 100%;
      left: 70%;
      background-color: #6d6e72;
    }
  }
`;

const FooterContainer = styled.div`
  display: flex;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  padding: 0 0 1rem 0;
  flex-direction: column;
  justify-content: space-between;

  .footer-logo {
    width: 106px;
    height: auto;
    margin: 0 auto;
  }

  p {
    color: #8b8c8f;
    font-size: 16px;
  }
  ul {
    padding-left: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    ${up(
      'md',
      css`
        flex-direction: row;
      `
    )};
  }
  li {
    font-size: 16px;
    color: #fff;
    text-align: center;
    padding: 5px 0;
    ${up(
      'md',
      css`
        padding: inherit;
        text-align: left;
      `
    )};
    a {
      color: #8b8c8f;
      text-decoration: underline;
      padding: 0.1rem 1rem;
      &:hover,
      &:focus {
        text-decoration: none;
      }
    }
  }

  .footer-right-text {
    padding: 0 1rem;
  }
`;

const Footer = () => (
  <FooterWrapper>
    <FooterContainer>
      <div className="pattern-container">
        <img src={PatternImg} alt="" className="pattern" />
      </div>
      <img src={FooterLogo} alt="GoodWe" className="footer-logo spacer" />
      <ul>
        <li>
          <Link to="/sitemap">Sitemap</Link>
        </li>
        <li>
          <Link to="/terms">Terms & Conditions</Link>
        </li>
        <li>
          <Link to="/privacy">Privacy Policy</Link>
        </li>
        <li>
          <Link to="/contact">Contact Us</Link>
        </li>
      </ul>
      <small className="text--center footer-right-text">
        &copy; {new Date().getFullYear()} All rights reserved. GoodWe Pty. Ltd.
      </small>
    </FooterContainer>
  </FooterWrapper>
);

export default withSettings(Footer);
